import { useTranslation } from 'react-i18next';

import type { Brand } from '~/types/user';

import { BrandDot } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  brand: Brand;
};

export const BrandColorCell = ({ brand }: Props) => {
  const { t } = useTranslation(['settings']);

  if (brand.isPrimary) return <div className={desktopTruncateStyle}>{t('settings:profile.brands.mainBrand')}</div>;

  return <BrandDot color={brand.color} />;
};
